export enum INVOICE_STATE {
    UNDEFINED = 0,
    NEW = 10,
    ASSIGN_REALESTATE = 15,
    ASSIGN_WORKFLOW_USERS = 20,
    RESTART_AFTER_REJECTED = 25,
    READY_FOR_VISA = 30,
    VISA_1_OK = 41,
    VISA_2_OK = 42,
    VISA_3_OK = 43,
    FULLY_SIGHTED = 49,
    SENT_TO_ERP = 50,
    IMPORTED_IN_ERP = 60,
    PAID = 90,
    REJECTED = 95,
    CANCELLED = 99
}

export enum INVOICE_LIST_STATE {
    NEW = 10, // States 10, 20, 25
    TO_APPROVE = 11, // States 30, 41, 42, 43
    PAY = 12, // States 49, 50, 60
    PAID = 90,
    REJECTED = 95,
    CANCELLED = 99,
    ALL = 100,
    ALL_OPEN = 101,
    ADDITIONAL_INVOICES = 102,
    IMPORT_DOCUMENTS = 200
}

export enum INVOICE_TYPE {
    INVOICE = 1,
    CREDIT = 2 // Refund, Gutschrift
}

export enum INVOICE_ORIGIN {
    MANUAL = 1,
    SCAN = 2,
    EMAIL = 3,
    TICKET = 4,
    DMS = 5
}

export enum INVOICE_PROPERTY {
    ID = "id",
    ORIGIN = "origin",
    WORKFLOW_INSTANCE = "workflowInstance",
    NUMBER = "number",
    INVOICE_NUMBER = "invoiceNumber",
    AMOUNT = "amount",
    DATE = "date",
    DUE_DATE = "dueDate",
    PAID_DATE = "paidDate",
    TITLE = "title",
    STATE = "state",
    INVOICE_TYPE = "invoiceType",
    TYPE = "type",
    REALESTATE = "realestate",
    REALESTATE_ID = "realestateId",
    REALESTATE_THUMBNAIL_FILEID = "realestateThumbnailFileId",
    UNIT = "unit",
    ASSIGNED_USER = "assignedUser",
    CREDITOR = "creditor",
    PAYMENT_ACCOUNT_ID = "paymentaccountid",
    PAYOUT_ACCOUNT_ID = "payoutaccountid",
    PAYMENT_INFO = "paymentInfo",
    PAYMENT_ACCOUNT = "paymentAccount",
    TICKET = "ticket",
    HISTORY = "history",
    COMMENT = "comment",
    ORDER = "order",
    INVOICE_FILE = "invoiceFile",
    INVOICE_ATTACHMENT_FILES = "invoiceAttachmentFiles",
    CREDITOR_INFO = "creditorInfo",
    INSERT_USER_ID = "insertUserId",
    INVOICE_INFO = "invoiceInfo",
    WORKFLOW_USERS = "workflowUsers",
    ACCOUNTINGS = "accountings",
    DUPLICATES = "duplicates",
    NUMBER_OF_VISA = "numberOfVisa",
    IS_PROCESSING = "isProcessing",
    PAYMENT_PURPOSE = "paymentPurpose"
}

export enum HISTORY_TYPE {
    INVOICE_CREATED,
    INVOICE_DATA_CHANGED,
    INVOICE_STATUS_CHANGED,
    INVOICE_AMOUNT_CHANGED,
    INVOICE_PAIDDATE_CHANGED,
    INVOICE_DUEDATE_CHANGED,
    INVOICE_CREDITOR_CHANGED,
    INVOICE_PAYMENTACCOUNT_CHANGED,
    INVOICE_PAYOUTACCOUNT_CHANGED,
    INVOICE_ORDER_CHANGED,
    INVOICE_UNIT_CHANGED,
    INVOICE_REALESTATE_CHANGED,
    INVOICE_NEW_WORKFLOWUSER_1,
    INVOICE_NEW_WORKFLOWUSER_2,
    INVOICE_NEW_WORKFLOWUSER_3,
    INVOICE_NEW_WORKFLOWUSER_4,
    INVOICE_NEW_DOCUMENT,
    INVOICE_DELETED_DOCUMENT,
    INVOICE_NEW_ACCOUNTING,
    INVOICE_REJECTED,
    INVOICE_CANCELLED,
    INVOICE_CHANGED_WORKFLOWUSERS,
    INVOICE_CHANGED_WORKFLOWUSERS_ROLE,
    INVOICE_CHANGED_WORKFLOWUSERS_SIGNATURE_1,
    INVOICE_CHANGED_WORKFLOWUSERS_SIGNATURE_2,
    INVOICE_CHANGED_WORKFLOWUSERS_SIGNATURE_3,
    INVOICE_CHANGED_WORKFLOWUSERS_SIGNATURE_4,
    INVOICE_CHANGED_DOCUMENT,
    INVOICE_CHANGED_ACCOUNTING,
    INVOICE_COMMENT,
    INVOICE_EMAIL_OUTBOUND,
    INVOICE_EMAIL_INBOUND
}

export enum INVOICE_PAYMENT_INFO_PROPERTY {
    IBAN = "iban",
    TYPE = "type",
    REFERENCE = "reference"
}

export enum IBAN_TYPE {
    NORMAL,
    QR
}

export enum INVOICE_CREDITOR_INFO_PROPERTY {
    NAME = "name",
    STREET = "street",
    HOUSNUMBER = "housnumber",
    ZIP = "zip",
    CITY = "city",
    COUNTRY = "country",
    UID = "uid"
}

export enum INVOICE_ACCOUNTING_PROPERTY {
    ID = "id",
    AMOUNT = "amount",
    DATE = "date",
    REALESTATE = "realestate",
    ACCOUNT = "account",
    COST_CENTER = "costCenter",
    TEXT = "text"
}

export enum INVOICE_ACCOUNTING_ACCOUNT_PROPERTY {
    ID = "id",
    NAME = "name",
    NUMBER = "number",
    TYPE = "type",
    VALID_FROM = "validFrom",
    VALID_TO = "validTo",
    REALESTATE = "realestate",
    TENANT = "tenant",
    REQUIRES_COST_CENTER = "requiresCostCenter",
    REQUIRED_QUANTITY = "requiredQuantity",
    UNIT_OF_MEASURE = "unitOfMeasure",
    VAT_CONFIG = "vatConfig",
    EXTRA_COST_DATE = "extraCostDate"
}

export enum INVOICE_ACCOUNTING_COST_CENTER_PROPERTY {
    ID = "id",
    NAME = "name",
    SHORT = "short"
}

export enum INVOICE_FIELD_TYPE {
    GENERAL,
    INVOICE_ATTACHMENT_FILES,
    PAYMENT_INFO,
    CREDITOR_INFO,
    INVOICE_INFO,
    ACCOUTING
}

export enum INVOICE_ACCOUNTING_FIELD_TYPE {
    GENERAL,
    ACCOUNT,
    COST_CENTER
}

export enum SORT {
    DATE_NEWEST = "dateNewest",
    DATE_OLDEST = "dateOldest"
}

export enum WORKFLOWUSER_ROLE {
    NONE = 0,
    VISA_1 = 1,
    VISA_2 = 2,
    VISA_3 = 3,
    ACCOUNTANT = 4,
    REJECTED_TO = 9,
    CANCELLED_BY = 10
}

export enum LOADING_TYPE {
    NONE,
    INITIALIZING,
    LOADING_INVOICE_DETAILS,
    SAVING_INVOICE,
    SAVING_COMMENT,
    REALESTATE_THUMBNAIL,
    TENANT_INFORMATION,
    OBJECT_UNITS
}

export enum LOADING_TYPE_ACCOUNTING {
    NONE,
    INITIALIZING,
    LOADING_ACCOUNTINGS,
    SAVING_ACCOUNTINGS
}

export enum RUNNING_SUBSCRIPTION_TPYE {
    NONE,
    WORKFLOW_USERS
}

export enum INVOICE_FILE_TYPE {
    INVOICE = 600,
    INPUTWORKFLOW_FILE = 603,
    INVOICE_ATTACHMENT = 604
}

export enum INVOICE_FILE_STATE {
    NONE,
    NEW,
    LOADED_FROM_DB,
    HAS_CHANGED,
    WAS_DELETED
}

export enum INPUTWORKFLOW_STATE {
    NEW = 1,
    ANALYZING = 3,
    MANUAL = 5,
    CREATING_INVOICES = 7,
    FINISHED = 9,
    UNAUTHORIZED_401 = 93,
    NOT_FOUND_404 = 94,
    INVALID_FILE_409 = 95,
    INTERNAL_SERVER_ERROR_500 = 96,
    BAD_GATEWAY_502 = 97,
    GENERAL_ERROR = 98,
    CANCELLED = 99,
    UI = 999
}

export enum INPUTWORKFLOW_FILE_STATE {
    NEW = 1,
    MANUAL = 5,
    READY = 10,
    CLOSED = 90,
    SPLITTED = 91,
    DELETED = 99
}

export enum INVOICE_ACCOUNT_TYPE {
    COST = 1,
    DEBTOR = 2,
    GENERAL_LEDGER = 3,
    COOPERATIVE = 4
}

export enum INVOICE_ACCOUNT_UNIT_OF_MEASURE {
    ZERO = 0, // Seeing this value (0) instead of 'null' in the DB. Will treat it as 'null' for now.
    LITER = 1,
    KWH = 2,
    KG = 3,
    M3 = 4,
    TON = 5,
    N_A = 9
}

export enum INVOICE_ACCOUNT_VAT_CONFIG {
    WITHOUT_VAT = 0,
    ALLOWS_VAT = 1,
    REQUIRES_VAT = 2,
    ONLY_DEFAULT_VATCODE = 3
}

export enum VAT_RATE_TYPE {
    UNDEFINED = 0,
    NORMAL_RATE = 1,
    REDUCED_RATE = 2,
    SPECIAL_RATE = 3,
    NO_VAT = 4
}

export enum PAYMENT_INFO_TYPE {
    QRR = "QRR",
    SCOR = "SCOR",
    NON = "NON"
}
